import renderDatetime from '../../../../../../../helpers/tables/render-datetime'
import type { MaterialOrderRequestColumn } from '../../types/column-types'

export const arrivalDateColumn: MaterialOrderRequestColumn = {
    title: 'Дата прихода',
    width: 100,
    render: (_value, record) => {
        if (record.requestStatus !== 'Обработан') {
            return undefined
        }

        const arrivalDate = record.receipt_position?.receipt?.estimatedDate

        return arrivalDate ? renderDatetime(arrivalDate) : undefined
    },
}
